export default __webpack_public_path__ + "static/media/nftport.517b7fbe.gif";